import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

OrderDetailEmailStatusController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  'HelpersService',
  'ApiService',
  'UserPreferencesService',
  'GridStateFactory',
  'GridDefinitionFactory',
];

function OrderDetailEmailStatusController(
  $scope,
  $state,
  $timeout,
  $filter,
  HelpersService,
  ApiService,
  UserPreferencesService,
  GridStateFactory,
  GridDefinitionFactory
) {
  $scope.emailStatusList = {
    model: [],

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    viewId: '',
    emailStatusListGridName: $state.current.name + '.grid0',
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

    optionsOverride: {
      useAccessibleGrid: true,
      rowHeight: 40,
      data: 'emailStatusList.model',
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          $scope.emailStatusList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function (grid, columns, page) {
          $scope.emailStatusList.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          // $scope.emailStatusList.onDblClick(item);
        },
        dateFormat: function (date) {
          return $filter('date')(date, $scope.emailStatusList.dateTimeFormat);
        },
      },
      columnDefs: [
        {
          field: 'email',
          displayName: 'Email',
          minWidth: 80,
        },
        {
          field: 'emailType',
          displayName: 'Type',
          minWidth: 30,
        },
        {
          field: 'emailStatus',
          displayName: 'Status',
          minWidth: 30,
        },
        {
          field: 'externalTemplateId',
          displayName: 'Template ID (SendGrid)',
          visible: false,
        },
        {
          field: 'account',
          displayName: 'Account (SendGrid)',
          visible: false,
        },
        {
          field: 'deliveredOn',
          displayName: 'Delivered on',
          cellTemplate:
            '<div class="ui-grid-cell-contents">{{ grid.appScope.dateFormat(row.entity.deliveredOn) }}</div>',
          sort: {
            direction: 'asc',
          },
          visible: false,
        },
        {
          field: 'emailStatusInfo',
          displayName: 'Status Reason',
          visible: false,
        },
        {
          field: 'responseCode',
          displayName: 'Response Code (SendGrid)',
          visible: false,
        },
        {
          field: 'responseMessage',
          displayName: 'Response Message (SendGrid)',
          visible: false,
        },
        {
          field: 'responseMessageId',
          displayName: 'Response Message ID (SendGrid)',
          visible: false,
        },
        {
          field: 'createdOn',
          displayName: 'Created on',
          cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.dateFormat(row.entity.createdOn) }}</div>',
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'updatedOn',
          displayName: 'Updated on',
          cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.dateFormat(row.entity.updatedOn) }}</div>',
          sort: {
            direction: 'asc',
          },
        },
      ],
    },

    init: function () {
      this.viewId = $state.current.name;

      this.gridDefinition.init(
        this.emailStatusListGridName,
        this.optionsOverride,
        this.viewId,
        $state.current.data.enablePreferences
      );

      $scope.$emit('Application::contentTitleChange', {
        title: 'Order Email Status',
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.go(-1);
          },
        },
        buttonRight: {
          label: 'Edit Order',
          permissions: ['ORDER_UPDATE'],
          action: function () {
            $state.go('application.orders.edit', { orderId: $scope.ordersDetail.model.orderId });
          },
          isDisabled: $scope.ordersDetail.isDisabled(),
        },
      });

      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
    },

    initData: function () {
      const self = $scope.emailStatusList;
      const props = self.gridDefinition.getGridState();

      self.onDateFormatLoad();
      self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      self.getEmailStatus(self.gridState);
    },

    getEmailStatus: function (page) {
      ApiService.emailStatus
        .detail($state.params.orderId, page)
        .then(this.success.getEmailStatus, this.error.getEmailStatus);
    },
    onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
      const self = $scope.emailStatusList;

      self.gridState.updateGridState(newPageNumber, newPageSize);
      if (sortField) {
        self.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        self.gridState.updateGridState(null, null, null, sortDirection);
      }

      self.getEmailStatus(self.gridState);
    },
    onDataGridSortChange: function (grid, columns, page) {
      const self = $scope.emailStatusList;
      const data = columns[0];

      self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);

      self.getEmailStatus(self.gridState);
    },

    onDateFormatLoad: function (e, data) {
      $scope.emailStatusList.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      $scope.emailStatusList.dateTimeFormat = UserPreferencesService.getDateTimeFormat('shortDateTime');
    },

    success: {
      init: function (response) {},
      getEmailStatus: function (response) {
        const self = $scope.emailStatusList;
        const pagination = response.data.payload.pagination;

        self.model = response.data.payload.list;

        if (!$scope.$$phase) {
          $scope.$apply();
        }

        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.model.length,
            totalItems: response.data.payload.pagination.count,
          });
        }, 10);
      },
    },

    error: {
      init: function (response) {},
      getEmailStatus: function () {},
    },
  };

  $scope.emailStatusList.init();
}

export const OrderDetailEmailStatusControllerModule = angular
  .module('acme.view.application.orders.detail.emailStatus.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.userPreferences',
  ])
  .controller('OrderDetailEmailStatusController', OrderDetailEmailStatusController).name;
